import { useToast } from '@repo/design-system/index'
import classNames from 'classnames'
import { useRef, useState } from 'react'
import { useCountdownTimer } from '../../../modules/hooks/common/useCountdownTimer'
import { s_preparation } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import AudioPlayer from './AudioPlayer'

const MaterialDesktopBottomTab = ({ course, isPreparation = false, className = '', isLanding = false }) => {
  const audioRef = useRef<HTMLAudioElement>(null)
  const [audioCurrentTime, setAudioCurrentTime] = useState(0)
  const [isAudioAuto, setIsAudioAuto] = useState(false)

  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const { start, pause, isRunning } = useCountdownTimer({
    timer: 10000,
  })

  const handlePauseAudio = () => {
    pause()
  }
  const handlePlayAudio = () => {
    start()
  }
  const handleEndAudio = async () => {
    toastSuccess(t(s_preparation.listenMp3))
  }

  if (!course) {
    return <></>
  }

  return (
    <>
      <div
        className={classNames(
          className,
          isPreparation
            ? 'z-[1000] hidden lg:sticky lg:flex lg:w-[calc(100%_-_80px)]'
            : 'right-[50%] hidden translate-x-1/2 lg:fixed lg:flex lg:w-[calc(100%_-_80px)]',
          course.mp3_link ? 'lg:justify-between' : 'lg:justify-end',
          'pointer-events-none bottom-[20px]  mx-auto min-h-[68px]  max-w-[1040px] pl-[56px]'
        )}
      >
        {course.mp3_link && (
          <div
            className={classNames(
              isPreparation
                ? 'border-1 flex w-[688px] rounded-[8px]'
                : 'border-1 flex w-full max-w-[688px] rounded-[8px]',
              'pointer-events-auto'
            )}
          >
            <AudioPlayer
              isLanding={isLanding}
              onPlay={() => handlePlayAudio()}
              onPause={() => handlePauseAudio()}
              onEnd={handleEndAudio}
              onClickRange={(time) => console.log(time)}
              ref={audioRef}
              src={course.mp3_link}
              playbacktime={course?.playback_time ? course?.playback_time : 0}
              audioCurrentTime={audioCurrentTime}
              setAudioCurrentTime={setAudioCurrentTime}
              isAudioAuto={isAudioAuto}
              setIsAudioAuto={setIsAudioAuto}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default MaterialDesktopBottomTab
